<template>
  <div class="page flex column">
    <app-header title="团队评价" ref="header" class="flex0">
      <i slot="back" class="back"></i>
    </app-header>
    <v-scroll class="main overflow-touch flex1 bg">
      <team-info class="info" :thumb="'radius'" :info="info" :showRateList="false"></team-info>
      <doc-comment-filter class="bb mt8" @change="change"></doc-comment-filter>
      <div class="list bg_fff">
        <rate-item v-for="(data,index) in list" :key="index" :data="data"></rate-item>
        <div class="nodata center" v-if="list.length==0">
          暂无评价信息
        </div>
      </div>
    </v-scroll>
  </div>
</template>

<script>
  import weuijs from 'weui.js'
  import TeamInfo from '../../plugins/team/info'
  import AppHeader from '../../plugins/app-header'
  import {mainHeightMixin} from "../../lib/mixin";
  import http from '../../lib/api'
  import RateItem from '../../plugins/rate-item'
  import DocCommentFilter from "../../plugins/doc/comment/filter";
  import {docService} from "../../services/doc";
  import VScroll from "../../plugins/v-scroll";

  export default {
    data() {
      return {
        info: {},
        id: '',
        list: [],
        form: {
          moudleType: 'TEAMPIC',
          moudleId: '',
          searchType: 'content',
          pageNum: 1
        },
        page: {},
      };
    },
    computed: {},
    mixins: [mainHeightMixin],
    components: {VScroll, DocCommentFilter, AppHeader, TeamInfo, RateItem},
    created() {
      let {id} = this.$route.params;
      if (id) {
        this.id = id;
        this.form.moudleId = id;
        this.getDetail();
        this.getRate();
      }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
      change(data) {
        this.list.splice(0);
        this.form.searchType = data;
        this.form.pageNum = 1;
        this.getRate();
      },
      async getDetail() {
        let loading = weuijs.loading("加载中...");
        let ret = await http('smarthos.team.info.card', {id: this.id});
        if (ret.code == 0) {
          this.info = ret.obj;
        }
        loading.hide();
      },
      async getRate() {
        const {list, paginator} = await docService.comment({...this.form});
        this.list = list;
        this.page = paginator;
      }

    }
  };
</script>

<style scoped lang="scss">
  @import "../../common/public";

  .main {
    .info {
      @include border();
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/team/rate.vue